module.exports = __webpack_public_path__ + "img/content-templates-banner.dd39346.jpg";